<!-- Pseudo cliquable menant au profil de l'utilisateur (/profil/:username) -->
<template>
  <router-link
    v-if="username"
    :to="{ name: 'UserProfile', params: { username } }"
    class="user-link"
    @click.stop
  >
    {{ username }}
  </router-link>
  <span v-else class="user-link-missing">Utilisateur supprimé</span>
</template>

<script>
export default {
  name: 'UserLink',
  props: {
    username: { type: String, default: '' },
  },
}
</script>

<style scoped>
.user-link {
  color: inherit;
  font-weight: inherit;
  text-decoration: none;
  cursor: pointer;
}

.user-link:hover {
  text-decoration: underline;
}

.user-link-missing {
  font-style: italic;
  color: #909399;
}
</style>
